/* eslint-disable */
import React, { useEffect } from 'react';
import { Box, List, ListItem, Card, CardContent, Accordion, AccordionSummary, Typography, AccordionDetails } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataListRow from './dataListRow';
import { createTheme } from '@mui/material/styles';
import EnhancedTableToolbar from '../../../sharedcomponents/tableToolbar/tableToolbar';
import Paging from '../../../sharedcomponents/pagination/pagination';
import DetailsComponent from '../../../sharedcomponents/detailsComponent/DetailsComponent';
import { useEventState } from '../../../stores/eventStore';
import { useState } from '@hookstate/core';
import Title from '../../../sharedcomponents/title/title';
import Helper from '../../../utility/helper';
import NotificationToolbar from '../../../sharedcomponents/notificationToolBar/notificationToolBar';
import moment from 'moment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    boxContent: {
        // paddingTop: theme.spacing(1),
    },
    listContent: {
        paddingBottom: theme.spacing(0),
        zIndex: 0,
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    accordionMain: {
        '& .MuiButtonBase-root': {
            '& .Mui-expanded': {
                minHeight: theme.spacing(4),
            },
        },
    },
    accordion: {
        backgroundColor: '#cccccc',
    },
    accordionHeader: {
        textTransform: 'uppercase',
        fontWeight: 600,
    },
}));

const DataList = (props) =>
{
    const classes = useStyles();
    const [listData, setListData] = React.useState([]);
    const [filterListData, setFilterListData] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [showToolbar, setShowToolbar] = React.useState(true);
    const eventState = useEventState();
    const moduleIndex = useState(-1);
    const [hotelRoomTaxID, setHotelRoomTaxID] = React.useState({
        index: '',
        value: 0,
    });
    const [dates, setDates] = React.useState([]);
    const [expanded, setExpanded] = React.useState([]);

    const info = Helper.getStorage('eventInfo');

    useEffect(() =>
    {
        setListData(props.data);
        setFilterListData(props.data);
 
        // code to hide top toolbar
        if (props.showTopbar != undefined && !props.showTopbar)
        {
            setShowToolbar(props.showTopbar);
        }
        //     if (listData && listData.length == 0 && filterListData.length == 0) {
        //         setListData(props.data);
        //         setFilterListData(props.data);
        //     } else if (
        //         props.showSearchRec &&
        //         props.data.length != listData.length
        //     ) {
        //         setListData(props.data);
        //         setFilterListData(props.data);
        //     } else if (!props.showSearchRec) {
        //         setListData(props.data);
        //         setFilterListData(props.data);
        //     }

        if (
            eventState &&
            eventState.eventDetail.get() != null &&
            props.moduleToShow != undefined
        )
        {
            getModuleDetailsData();
        }
    }, [props]);
    useEffect(() =>
    {
        if (props?.data !== null)
        {
            getDistinctDates(props.data);
        }

    }, [props.data])
    const getModuleDetailsData = () =>
    {
        const index = eventState.eventDetail
            .get()
            .moduleDetails.findIndex((element) =>
            {
                if (
                    element.moduleName ===
                    (props.titleHeader ? props.titleHeader : props.moduleToShow)
                )
                {
                    return true;
                }
            });
        moduleIndex.set(index);
    };

    // this need to be modified
    const handleFilterChangeValue = (filterObj) =>
    {
        let modifyList = listData.filter((item) =>
        {
            const data = item.actualData;
            if (filterObj)
            {
                return Object.keys(filterObj).every((filter) =>
                {
                    let val =
                        typeof filterObj[filter] === 'string' &&
                            filter === 'transportType'
                            ? filterObj[filter].toLowerCase()
                            : filterObj[filter];
                    return val.includes(data[filter]);
                });
            }
        });

        if (filterObj)
        {
            if (props.setShowSearchRec != undefined)
            {
                props.setShowSearchRec(true);
            }
            setFilterListData(modifyList);
            props.filterListData(modifyList);
        } else
        {
            if (props.setShowSearchRec != undefined)
            {
                props.setShowSearchRec(false);
            }
            setFilterListData(listData);
            if (props.filterListData) props.filterListData(listData);
        }
    };

    const handleOnChange = (event) =>
    {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        if (value.length > 0)
        {
            if (props.setShowSearchRec != undefined)
            {
                props.setShowSearchRec(true);
            }
            let modifyList = [];
            listData.forEach((item) =>
            {
                let data = item.actualData;
                let keys = Object.keys(data);
                keys.forEach((key) =>
                {
                    // console.log(data[key]);
                    if (
                        typeof data[key] === 'string' &&
                        data[key].toLowerCase().indexOf(value.toLowerCase()) >
                        -1
                    )
                    {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                });
            });
            setFilterListData(modifyList);
            if (props.filterListData) props.filterListData(modifyList);
        } else
        {
            if (props.setShowSearchRec != undefined)
            {
                props.setShowSearchRec(false);
            }
            setFilterListData(listData);
            if (props.filterListData) props.filterListData(listData);
        }
    };
    const onCheckSelect = (event, index) =>
    {
        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.checked;
        setFilterListData(newFilterList);
    };
    const onCheckSelectAll = (event) =>
    {
        let newFilterList = [...filterListData];
        newFilterList.forEach((item, index) =>
        {
            if (props.showSendInvite && props.showSendInvite !== undefined)
            {
                if (item.actualData.email !== null)
                {
                    const nbaDomain = item.actualData.email.split('@');
                    // console.log("nbaDomain", nbaDomain[1]);
                    if (
                        item.actualData.registerDate === null &&
                        nbaDomain &&
                        nbaDomain[1] !== 'nba.com'
                    )
                    {
                        newFilterList[index]['selected'] = event.target.checked;
                    }
                }
            } else
            {
                newFilterList[index]['selected'] = event.target.checked;
            }
        });
        setFilterListData(newFilterList);
    };



    const handleEditAll = () =>
    {
        props.editAllToggle();
    };
    const handleHotelSave = () =>
    {
        let newFilterList = [...filterListData];
        props.editAll(newFilterList);
    };
    const getDistinctDates = (data) =>
    {
        // console.log("data", data);
        let activityDates = [];
        data.map((item) =>
        {
            let startDate =
                item.actualData.headerDate !== null
                    ? moment(item.actualData.headerDate).format('MM/DD/YYYY')
                    : null;
            let endDate = null; //item.actualData.endDateTime !== null ? moment(item.actualData.endDateTime).format('MM/DD/YYYY') : null;
            let range = [];
            if (startDate !== null && endDate !== null)
            {
                range = getDates(moment(startDate), moment(endDate));
            } else if (startDate !== null && endDate === null)
            {
                range = [startDate];
            } else if (startDate === null && endDate !== null)
            {
                range = [endDate];
            }
            //let range = getDates(moment(startDate), moment(endDate))

            activityDates = [...activityDates, ...range];
        });
        let uniqueDates = [...new Set(activityDates)];
        let TBDindex = uniqueDates.indexOf('TBD');

        uniqueDates = uniqueDates.sort((a, b) => moment(a) - moment(b));

        // console.log("uniqueDates", uniqueDates);
        setDates(uniqueDates);
        setExpanded(uniqueDates.map(() => true));
    };
    // const handleChange = (index) => (event, isExpanded) => {
    //     let newExpanded = [...expanded];
    //     newExpanded[index] = isExpanded;
    //     setExpanded(newExpanded);
    // };
    return (
        <Box className={classes.boxContent}>
            {props.moduleToShow ? <Title title={props.moduleToShow} /> : null}
            {props.moduleToShow != undefined &&
                eventState.eventDetail.get() &&
                ((moduleIndex.get() >= 0 &&
                    eventState.eventDetail.get().moduleDetails[
                        moduleIndex.get()
                    ].details != null) ||
                    '') && (
                    <DetailsComponent
                        data={
                            eventState.eventDetail.get().moduleDetails[
                                moduleIndex.get()
                            ].details
                        }
                    />
                )}
            {showToolbar ? (
                <EnhancedTableToolbar
                    {...props}
                    search={search}
                    showSendAll={props.showSendAll ? true : false}
                    sendAllbuttonTitle={props.showSendAll ? 'Send All' : null}
                    showEdit={props.showEdit ? true : false}
                    editButtonTitle={props.showEdit ? true : false}
                    handleSearchChange={handleOnChange}
                    handleFilterChange={handleFilterChangeValue}
                    handleSendEmail={props.handleSendEmail}
                    hideAdd={props.hideAdd ? true : false}
                    modPermission={props.modPermission}
                    disableAdd={props.disableAdd}
                    onCheckSelectAll={onCheckSelectAll}
                    showEditHotel={props.showEditHotel ? true : false}
                    handleEditAll={handleEditAll}
                    showHotelToggle={props.showHotelToggle}
                    saveHotelButtonTitle={props.saveHotelButtonTitle}
                    handleHotelSave={handleHotelSave}
                    eventConfigStatus={props.eventConfigStatus}
                    compUsed={props.compUsed}
                    purchaseUsed={props.purchaseUsed}
                    readOnlyOrHide={info && info.readonlyOrHide}
                />
            ) : !props.hideToolBar && (
                <NotificationToolbar
                    {...props}
                    search={search}
                    handleSearchChange={handleOnChange}
                    onCheckSelectAll={onCheckSelectAll}
                    showSearch={props.showSearch}
                />
            )}
            {/* {dates.length > 0 ? (
                dates.map((date, index) => {
                    let list = [...listData];
                    let data = list.filter((x) => {
                        if (x.actualData.headerDate !== null) {
                            //&& x.actualData.endDateTime !== null
                            if (
                                moment(date).format('MM/DD/YYY') ==
                                moment(
                                    x.actualData.headerDate
                                ).format('MM/DD/YYY')
                            ) {
                                return x;
                            }
                        } else if (
                            date === 'TBD' &&
                            x.actualData.startDateTime === null &&
                            x.actualData.endDateTime === null
                        )
                            return x;
                    });
                    // console.log("data", data);
                    return (
                        <Accordion
                            key={index}
                            expanded={true}
                        // onChange={handleChange(index)}
                        >
                            <AccordionSummary
                                // expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index + 1
                                    }bh-content`}
                                id={`panel${index + 1}bh-header`}
                                className={classes.accordion}>
                                <Typography
                                    sx={{ width: '33%', flexShrink: 0 }}
                                    className={classes.accordionHeader}>
                                    {date !== 'TBD'
                                        ? moment(date).format(
                                            'dddd, MMMM D, YYYY'
                                        )
                                        : date}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <List className={classes.listContent}>
                                    {data && data.length > 0 ? (
                                        data.map((item, index) => (
                                            <DataListRow
                                                {...props}
                                                key={`datarow_${index}`}
                                                item={item}
                                                index={index}
                                                onCheckSelect={onCheckSelect}
                                                onCheckSelectAll={onCheckSelectAll}
                                                editRow={props.editRow}
                                                editTemplate={props.editTemplate}
                                                editSendEmail={props.editSendEmail}
                                                viewPage={props.viewPage}
                                                onSwitchToggle={props.onSwitchToggle}
                                                onActionClick={props.onActionClick}
                                                onPendingAction={props.onPendingAction}
                                                addConnection={props.addConnection}
                                                addConnectionLinkedWith={
                                                    props.addConnectionLinkedWith
                                                }
                                                deleteConnection={props.deleteConnection}
                                                modPermission={props.modPermission}
                                                copyToClipboard={props.copyToClipboard}
                                                outfitInfo={props.outfitInfo}
                                                onChangeHotelRoom={onChangeHotelRoom}
                                                hotelRoomTaxID={hotelRoomTaxID}
                                                hotelKeyValue={props.hotelKeyValue}
                                                readOnlyOrHide={info && info.readonlyOrHide}
                                            />
                                        ))
                                    ) : ( */}
            {filterListData && filterListData.length > 0 ? (
                filterListData.map((item, index) => (
                    <DataListRow
                        {...props}
                        key={`datarow_${index}`}
                        item={item}
                        index={index}
                        onCheckSelect={onCheckSelect}
                        showEdit={props.showEdit ? true : false}
                        editRow={props.editRow}
                        socialInfo={props.options}
                    />
                ))
            ) : (
                <ListItem className={classes.listItemContent}>
                    <Card
                        classes={{ root: classes.paperContent }}
                        sx={{ width: '100%' }}>
                        <CardContent
                            sx={{ p: 2 }}
                            className={classes.cardContent}>
                            <Box className={classes.rowContent}>
                                No data found
                            </Box>
                        </CardContent>
                    </Card>
                </ListItem>
            )}

            {props.pagingInfo &&
                props.pagingInfo.noOfPages > 1 &&
                !props.showSearchRec ? (
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Paging
                        pagingInfo={props.pagingInfo}
                        handlePageChange={props.handlePageChange}
                    />
                </Box>
            ) : null}
        </Box>
    );
};

export default DataList;
